import { render, staticRenderFns } from "./SortedAscIcon.vue?vue&type=template&id=3b4f2807&"
import script from "./SortedAscIcon.vue?vue&type=script&lang=js&"
export * from "./SortedAscIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports